import {
  AgxButton,
  AgxSpacer,
  AgxTypography,
  Icon_Arrow,
  Icon_CheckmarkOutline,
  Icon_EditOutline,
  Icon_Link,
  Icon_FileTextOutline,
  Icon_Refresh,
  Icon_ListOutline,
  Icon_TargetOutline,
} from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import Panel from 'components/panel/Panel';
import { Link } from 'react-router-dom';
import { StaffRole } from '@urbanx/agx.auth.client';
import { useDoesUserHasRequiredRoles } from 'helpers/doesUserHaveRequiredRoles';

const SupportTools = () => {
  const doesUserHaveRequiredRoles = useDoesUserHasRequiredRoles();
  const canUseManualDocuSignUpdates = doesUserHaveRequiredRoles([StaffRole.SuperAdmin]);

  return (
    <AgxSpacer direction="horizontal" gap="spacing-xl" fill wrap>
      <Panel
        title="Disconnect Rex listing"
        halfWidth
        actionContent={
          <AgxButton
            id="support-disconnect-rex-link"
            text="Open"
            variant="primary"
            size="small"
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_REX_DISCONNECTION} {...props} />}
          />
        }
      >
        <AgxTypography id="support-disconnect-rex-summary" type="body" size="small">
          Disconnect a campaign from Rex and record the reason
        </AgxTypography>
      </Panel>
      <Panel
        title="Service queues"
        actionContent={
          <AgxButton
            id="support-service-queues-link"
            text="Open"
            variant="primary"
            size="small"
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_QUEUES} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-service-queues-summary" type="body" size="small">
            Queue failures and message replay
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Migrations"
        actionContent={
          <AgxButton
            id="support-migrations-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Refresh width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_MIGRATIONS} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-migrations-summary" type="body" size="small">
            Migration status and manual runs
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Update Legal Name"
        actionContent={
          <AgxButton
            id="support-update-legal-name-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_EditOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_UPDATE_LEGAL_NAME} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-update-legal-name-summary" type="body" size="small">
            Campaign vendor legal-name updates
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Update Campaign and Contract Status"
        actionContent={
          <AgxButton
            id="support-update-campaign-status-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_CheckmarkOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_UPDATE_CAMPAIGN_STATUS} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-update-campaign-status-summary" type="body" size="small">
            Campaign and contract stage override updates
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Task Progressor"
        actionContent={
          <AgxButton
            id="support-task-progressor-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_ListOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_TASK_PROGRESSOR} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-task-progressor-summary" type="body" size="small">
            Staff task initialisation and workflow progression
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="CRM Support"
        actionContent={
          <AgxButton
            id="support-crm-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Link width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_CRM} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-crm-summary" type="body" size="small">
            CRM resyncs and operational support
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Restore Soft Deleted Agent"
        actionContent={
          <AgxButton
            id="support-restore-soft-deleted-agent-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Refresh width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => (
              <Link to={Pages.SUPPORT_RESTORE_SOFT_DELETED_AGENT} {...props} />
            )}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-restore-soft-deleted-agent-summary" type="body" size="small">
            Restore agents by clearing their soft-deleted flag
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Agent Integrations"
        actionContent={
          <AgxButton
            id="support-agent-integrations-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_Link width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_AGENT_INTEGRATIONS} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-agent-integrations-summary" type="body" size="small">
            View and reset agent DocuSign and RP Data connections
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      <Panel
        title="Leaderboard Visibility"
        actionContent={
          <AgxButton
            id="support-leaderboard-visibility-link"
            text="Open"
            variant="primary"
            size="small"
            leftIcon={<Icon_TargetOutline width={16} height={16} />}
            rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
            renderLink={(props) => <Link to={Pages.SUPPORT_LEADERBOARD_VISIBILITY} {...props} />}
          />
        }
        halfWidth
      >
        <AgxSpacer gap="spacing-sm">
          <AgxTypography id="support-leaderboard-visibility-summary" type="body" size="small">
            Include or exclude agencies and agents from Top Performers leaderboards
          </AgxTypography>
        </AgxSpacer>
      </Panel>

      {canUseManualDocuSignUpdates && (
        <Panel
          title="Identity migration"
          halfWidth
          actionContent={
            <AgxButton
              id="support-identity-migration-link"
              text="Open"
              variant="primary"
              size="small"
              renderLink={(props) => <Link to={Pages.SUPPORT_IDENTITY_MIGRATION} {...props} />}
            />
          }
        >
          <AgxTypography id="support-identity-migration-summary" type="body" size="small">
            Move a person to a new login email
          </AgxTypography>
        </Panel>
      )}
      {canUseManualDocuSignUpdates && (
        <Panel
          title="Manual DocuSign Updates"
          actionContent={
            <AgxButton
              id="support-manual-docusign-updates-link"
              text="Open"
              variant="primary"
              size="small"
              leftIcon={<Icon_FileTextOutline width={16} height={16} />}
              rightIcon={<Icon_Arrow direction="right" width={16} height={16} />}
              renderLink={(props) => <Link to={Pages.SUPPORT_MANUAL_DOCUSIGN_UPDATES} {...props} />}
            />
          }
          halfWidth
        >
          <AgxSpacer gap="spacing-sm">
            <AgxTypography id="support-manual-docusign-updates-summary" type="body" size="small">
              Manual envelope and recipient signing updates
            </AgxTypography>
          </AgxSpacer>
        </Panel>
      )}
    </AgxSpacer>
  );
};

export default SupportTools;
